import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import * as React from "react";
import Slider from "react-slick";
import { setCustomArrowsFocus } from "../../../Shared/utils/ui";
import { Link } from "./library/link";
export const QuickLinks = (p)=>{
    const links = p.links.map((c, i)=>/*#__PURE__*/ _jsx("li", {
            className: "quicklink",
            children: /*#__PURE__*/ _jsx("div", {
                className: "quicklink__inner",
                children: /*#__PURE__*/ _jsx(Link, {
                    url: c.url,
                    title: c.title,
                    className: "quicklink__link",
                    handle: ()=>{
                        p.pushAnalyticsEvent(c.title);
                        if (c.url.startsWith("#")) {
                            p.handleScroll(c.url.substring(1));
                        }
                    },
                    children: c.title
                })
            })
        }, `group-scroll-${i}`));
    return /*#__PURE__*/ _jsxs("nav", {
        className: `quicklinks ${p.className ? p.className : ""}`,
        "aria-label": "Snelkoppelingen",
        children: [
            p.title ? /*#__PURE__*/ _jsx("p", {
                className: "quicklinks__title",
                children: p.title
            }) : /*#__PURE__*/ _jsx(_Fragment, {}),
            !p.slider ? /*#__PURE__*/ _jsx("ul", {
                className: "quicklinks__list",
                children: links
            }) : /*#__PURE__*/ _jsx(Slider, {
                accessibility: true,
                dots: false,
                arrows: true,
                infinite: false,
                variableWidth: true,
                className: p.sliderClassName ? p.sliderClassName : "menuslider",
                speed: 500,
                swipeToSlide: true,
                slidesToScroll: 3,
                centerMode: false,
                responsive: [
                    {
                        breakpoint: 1024,
                        settings: {
                            slidesToScroll: 1
                        }
                    }
                ],
                onReInit: ()=>{
                    const slides = document.querySelectorAll('.slick-slide');
                    slides.forEach((slide)=>{
                        slide.setAttribute('aria-hidden', 'false');
                    });
                    setCustomArrowsFocus();
                },
                slickPrev: ()=>{
                    setCustomArrowsFocus();
                },
                slickNext: ()=>{
                    setCustomArrowsFocus();
                },
                children: links
            })
        ]
    });
};
